import { useEffect, useState } from "react";
export const useIsEllipsisActive = (inputRef) => {
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    useEffect(() => {
        if (inputRef.current) {
            const { scrollWidth, clientWidth } = inputRef.current;
            setIsEllipsisActive(scrollWidth > clientWidth);
        }
    });
    return isEllipsisActive;
};
//# sourceMappingURL=useIsEllipsisActive.js.map